module.exports = __webpack_public_path__ + "static/media/tyrell_power.e095693b.png";